import { defineComponent as _defineComponent } from 'vue'
import { Modal, Heading, BaseText } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  isOpen: boolean;
  title: string;
  description: string;
}
interface Emits {
  (e: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipModal',
  props: {
    isOpen: { type: Boolean },
    title: null,
    description: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const handleClose = () => {
  emit('close');
};

return { __sfc: true,emit, handleClose, Modal, Heading, BaseText, NebraskaColors }
}

})